export const MailFormat = {
    Mail: 1,
    Email: 2
};